import React, { useCallback, useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AssignmentIcon from "@mui/icons-material/Assignment";
import baseUrl from "../../../../../api/baseUrl";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setPurpose } from "../../../../../redux/appointment/appointmentAction";
import { RootState } from "../../../../../redux/store";
import { Hourglass } from "react-loader-spinner";
import { Socket, connect } from "socket.io-client";
import socketauth from "../../../../../api/socket";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import EventIcon from "@mui/icons-material/Event";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SkipNextIcon from "@mui/icons-material/SkipNext";

const socket: Socket = connect(`${process.env.REACT_APP_WS}`, socketauth);

function AppointmentsSchedule({
  setappointmentModal,
  appointmentDetail,
  doctor,
  onsave,
  selectReSchedule,
  setSelectReSchedule,
  timeSlots,
  events,
  tray,
  setAppointmentDetail,
  setAppointmentType,
}: any) {
  const [selectedOption, setSelectedOption] = useState<string>("Schedule");
  const [error, seterror] = useState(false);
  const [lodingBtn, setlodingBtn] = useState(false);
  const purposes = useSelector((state: RootState) => state.appointment);

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
  };

  const timeToMinutes = useCallback((timeString: string): number => {
    const [hoursStr, minutesStr] = timeString.split(":");
    return parseInt(hoursStr) * 60 + parseInt(minutesStr);
  }, []);

  const subtractTimes = useCallback(
    (startTime: string, endTime: string): number => {
      return timeToMinutes(endTime) - timeToMinutes(startTime);
    },
    [timeToMinutes]
  );

  const addMinutesToTime = useCallback(
    (time: string, minutesToAdd: number): string => {
      return new Date(
        new Date(`2024-01-01T${time}`).getTime() + minutesToAdd * 60000
      ).toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    []
  );

  const formatTime = useCallback((dates?: any) => {
    const date = new Date(dates);
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  }, []);

  const [formData, setformData] = useState({
    purposeId: "",
    sStartTime: appointmentDetail?.slots
      ? formatTime(appointmentDetail?.slots[0])
      : "",
    sEndTime: appointmentDetail?.slots
      ? formatTime(appointmentDetail?.slots[1])
      : "",
    sInterval: "5",
    rInterval: "5",
    sDate: appointmentDetail?.start,
    rStartTime: appointmentDetail?.slots
      ? formatTime(appointmentDetail?.slots[0])
      : "",
    rEndTime: appointmentDetail?.slots
      ? formatTime(appointmentDetail?.slots[appointmentDetail?.slots.length - 1])
      : "",
    rDate: appointmentDetail?.start,
    sDoctorId: appointmentDetail?.doctorId,
    rDoctorId: appointmentDetail?.doctorId,
    name: appointmentDetail?.name,
    mobileNo: appointmentDetail?.mobileNo,
    patientId: appointmentDetail?.patientId,
  });

  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const getPurpose = useCallback(() => {
    baseUrl
      .get("client/appointment/makeappointment/findAllPurpose")
      .then((response) => {
        dispatch(setPurpose(response.data.data, false));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getdata = useCallback(() => {
    setSelectedOption("Schedule");

    if (appointmentDetail?.action === "Reschedule") {
      setSelectedOption("Reschedule");
      baseUrl
        .get("appointment/findAppointmentById", {
          headers: { appointmentid: appointmentDetail?.appointmentId },
        })
        .then((response) => {
          const item = response.data.data;
          console.log(item);
          setformData({
            ...formData,
            purposeId: item?.purposeId,
            name: item?.patientId?.fullName,
            mobileNo: item?.patientId?.mobileNo,
            patientId: item?.patientId?.patientId,
            rDate: appointmentDetail?.start || item?.date?.split("T")[0],
            rStartTime: appointmentDetail?.startTime || item?.startTime,
            rEndTime: appointmentDetail?.endTime || item?.endTime,
            rInterval: item?.interval,
            rDoctorId: appointmentDetail?.doctorId || item?.doctorId,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (appointmentDetail?.action === "Completed") {
      setSelectedOption("");
      baseUrl
        .get("appointment/findAppointmentById", {
          headers: { appointmentid: appointmentDetail?.appointmentId },
        })
        .then((response) => {
          const item = response.data.data;

          setformData({
            ...formData,
            purposeId: item?.purposeId,
            rStartTime: item?.startTime,
            rInterval: item?.interval,
            rEndTime: item?.endTime,
            rDate: item?.date.split("T")[0],
            rDoctorId: item?.doctorId,
            name: item?.patientId?.fullName,
            mobileNo: item?.patientId?.mobileNo,
            patientId: item?.patientId?.patientId,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [appointmentDetail]);

  useEffect(() => {
    if (purposes?.purposeIsEMpty) getPurpose();
    getdata();
  }, [getdata, getPurpose]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "sInterval") {
      setformData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
        sEndTime: addMinutesToTime(formData.sStartTime, parseInt(value)),
      }));
    } else if (name === "rInterval") {
      setformData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
        rEndTime: addMinutesToTime(formData.rStartTime, parseInt(value)),
      }));
    } else if (name === "sEndTime") {
      const differenceInMinutes = subtractTimes(formData.sStartTime, value);
      setformData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
        sInterval: differenceInMinutes.toString(),
      }));
    } else if (name === "rEndTime") {
      const differenceInMinutes = subtractTimes(formData.sStartTime, value);
      setformData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
        rInterval: differenceInMinutes.toString(),
      }));
    } else {
      setformData((prevFormData: any) => ({ ...prevFormData, [name]: value }));
    }
  };

  const handleSave = () => {
    seterror(false);
    setlodingBtn(true);
    if (selectedOption === "") {
      toast.error("select an action");
      setlodingBtn(false);
      return;
    }
    if (selectedOption === "Schedule") {
      if (formData.purposeId === "") {
        seterror(true);
        setlodingBtn(false);
        return;
      }
      const datas = {
        doctorId: appointmentDetail.doctorId,
        patientId: appointmentDetail?.patientId,
        activeTime: appointmentDetail?.activeTime,
        date: formData.sDate,
        startTime: formData.sStartTime,
        endTime: formData.sEndTime,
        interval: formData.sInterval,
        purpose: formData.purposeId,
      };
      const dataSocket = {
        doctorId: appointmentDetail.doctorId,
        patientId: {
          _id: appointmentDetail?.patientId,
          fullName: formData?.name,
        },
        activeTime: appointmentDetail?.activeTime,
        date: formData.sDate,
        startTime: formData.sStartTime,
        endTime: formData.sEndTime,
        interval: formData.sInterval,
        purposeId: {
          purposeName: purposes?.purpose?.find(
            (item: any) => item._id === formData.purposeId
          ).purposeName,
        },
      };
      socket.emit("newAppointment", dataSocket);
      baseUrl
        .post("/appointment/createAppointment", datas)
        .then((response) => {
          setappointmentModal(false);
          setSelectedOption("Schedule");
          onsave(datas);
          setlodingBtn(false);
        })
        .catch((error) => {
          console.log(error);
          setlodingBtn(false);
        });
    } else if (selectedOption === "rescheduletray") {
      baseUrl
        .patch(
          "/appointment/statusAppointmentById",
          {},
          {
            headers: {
              appointmentid: appointmentDetail?.appointmentId,
              status: "tray",
            },
          }
        )
        .then((response) => {
          setlodingBtn(false);
          onsave();
          setappointmentModal(false);
        })
        .catch((error) => {
          setlodingBtn(false);
          console.log(error);
        });
    } else if (selectedOption === "Reschedule") {
      if (formData.purposeId === "") {
        seterror(true);
        setlodingBtn(false);
        return;
      }
      const datas = {
        doctorId: formData.rDoctorId,
        patientId: formData?.patientId,
        date: formData.rDate,
        startTime: formData.rStartTime,
        endTime: formData.rEndTime,
        interval: formData.rInterval,
        purpose: formData.purposeId,
      };
      baseUrl
        .patch("/appointment/reschedule", datas, {
          headers: {
            appointmentid: appointmentDetail?.appointmentId,
            status: "appointment",
          },
        })
        .then((response) => {
          // If from reschedule tray, move to next appointment in tray
          if (appointmentDetail?.fromRescheduleTray && setSelectReSchedule && tray && tray.length > 0) {
            // Find current appointment index
            const currentIndex = tray.findIndex((item: any) => item._id === appointmentDetail?.appointmentId);

            if (currentIndex !== -1 && currentIndex < tray.length - 1) {
              // Move to next appointment in tray
              const nextAppointment = tray[currentIndex + 1];
              setSelectReSchedule(nextAppointment._id);

              // Fetch next appointment data
              baseUrl
                .get("appointment/findAppointmentById", {
                  headers: { appointmentid: nextAppointment._id },
                })
                .then((response) => {
                  const item = response.data.data;

                  // Update appointment detail for next appointment
                  setAppointmentType("Reschedule");
                  setAppointmentDetail({
                    action: "Reschedule",
                    appointmentId: nextAppointment._id,
                    fromRescheduleTray: true,
                  });

                  // Populate form with next appointment data
                  setformData((prev: any) => ({
                    ...prev,
                    purposeId: item?.purposeId,
                    name: item?.patientId?.fullName,
                    mobileNo: item?.patientId?.mobileNo,
                    patientId: item?.patientId?.patientId,
                    rDate: item?.date?.split("T")[0],
                    rStartTime: item?.startTime,
                    rEndTime: item?.endTime,
                    rInterval: item?.interval,
                    rDoctorId: item?.doctorId,
                  }));

                  setlodingBtn(false);
                  toast.success("Appointment rescheduled! Moving to next appointment...");
                })
                .catch((error) => {
                  console.error("Error fetching next appointment:", error);
                  setlodingBtn(false);
                  toast.error("Failed to load next appointment");
                });

              // Refresh appointments list
              onsave();
            } else {
              // No more appointments, clear selection and close
              setSelectReSchedule("");
              onsave();
              setlodingBtn(false);
              setappointmentModal(false);
              toast.success("All appointments rescheduled!");
            }
          } else {
            // Not from reschedule tray or no more appointments
            if (appointmentDetail?.fromRescheduleTray && setSelectReSchedule) {
              setSelectReSchedule("");
            }
            onsave();
            setlodingBtn(false);
            setappointmentModal(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setlodingBtn(false);
        });
    } else if (selectedOption === "Completed") {
      baseUrl
        .patch(
          "/appointment/completeAppointment",
          {},
          { headers: { appointmentid: appointmentDetail?.appointmentId } }
        )
        .then((response) => {
          setappointmentModal(false);
          setSelectedOption("Schedule");
          onsave();
          setlodingBtn(false);
        })
        .catch((error) => {
          console.log(error);
          setlodingBtn(false);
        });
    } else if (selectedOption === "cancel") {
      baseUrl
        .patch(
          "/appointment/cancelAppointment",
          {},
          { headers: { appointmentid: appointmentDetail?.appointmentId } }
        )
        .then((response) => {
          setappointmentModal(false);
          onsave();
          setSelectedOption("Schedule");
          setlodingBtn(false);
        })
        .catch((error) => {
          console.log(error);
          setlodingBtn(false);
        });
    }
  };

  const handleCancel = () => {
    // Prevent closing if in forced reschedule mode from reschedule tray
    if (appointmentDetail?.fromRescheduleTray && selectReSchedule) {
      return; // Don't allow closing without completing reschedule
    }
    setSelectedOption("Schedule");
    setappointmentModal(false);
  };

  const handleMoveToNext = () => {
    if (!timeSlots || timeSlots.length === 0) {
      toast.error("No available time slots found");
      return;
    }

    const now = new Date();
    const currentDate = formData.rDate ? new Date(formData.rDate) : new Date();
    const interval = parseInt(formData.rInterval) || 30;

    // Start from today or selected date
    let checkDate = new Date(currentDate);
    if (checkDate < now) {
      checkDate = new Date(now);
      checkDate.setHours(0, 0, 0, 0);
    }

    // Try to find next available slot within next 30 days
    for (let dayOffset = 0; dayOffset < 30; dayOffset++) {
      const checkDay = new Date(checkDate);
      checkDay.setDate(checkDate.getDate() + dayOffset);
      const dayOfWeek = checkDay.getDay();

      // Find working hours for this day
      const dayWorkingHours = timeSlots.find((slot: any) => slot.day === dayOfWeek);

      if (!dayWorkingHours) continue;

      const startHour = dayWorkingHours.start.hours;
      const startMinute = dayWorkingHours.start.minutes;
      const endHour = dayWorkingHours.end.hours;
      const endMinute = dayWorkingHours.end.minutes;

      // Check if it's today - start from current time or working hours start
      let startCheckHour = startHour;
      let startCheckMinute = startMinute;

      if (dayOffset === 0) {
        const currentHour = now.getHours();
        const currentMin = now.getMinutes();
        if (currentHour > startHour || (currentHour === startHour && currentMin >= startMinute)) {
          startCheckHour = currentHour;
          startCheckMinute = Math.ceil(currentMin / 5) * 5; // Round up to nearest 5 minutes
          if (startCheckMinute >= 60) {
            startCheckHour++;
            startCheckMinute = 0;
          }
        }
      }

      // Check available slots for this day
      for (let hour = startCheckHour; hour < endHour || (hour === endHour && startCheckMinute < endMinute); hour++) {
        const startMin = hour === startCheckHour ? startCheckMinute : 0;
        const endMin = hour === endHour ? endMinute : 60;

        for (let minute = startMin; minute < endMin; minute += 5) {
          const slotStart = new Date(checkDay);
          slotStart.setHours(hour, minute, 0, 0);

          const slotEnd = new Date(slotStart);
          slotEnd.setMinutes(slotEnd.getMinutes() + interval);

          // Check if this slot overlaps with existing events
          const isOverlapping = events?.some((event: any) => {
            const eventStart = new Date(event.start);
            const eventEnd = new Date(event.end);
            return slotStart < eventEnd && slotEnd > eventStart;
          });

          if (!isOverlapping) {
            // Found available slot
            const startTimeStr = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            const endTime = new Date(slotStart);
            endTime.setMinutes(endTime.getMinutes() + interval);
            const endTimeStr = `${String(endTime.getHours()).padStart(2, '0')}:${String(endTime.getMinutes()).padStart(2, '0')}`;

            setformData((prev: any) => ({
              ...prev,
              rDate: checkDay,
              rStartTime: startTimeStr,
              rEndTime: endTimeStr,
              rInterval: interval.toString(),
            }));

            toast.success(`Moved to next available slot: ${moment(checkDay).format('MMM DD, YYYY')} at ${startTimeStr}`);
            return;
          }
        }
      }
    }

    toast.error("No available time slots found in the next 30 days");
  };

  const actionOptions = [
    { value: "rescheduletray", label: "Put To Reschedule", icon: <PendingActionsIcon sx={{ fontSize: 18 }} />, color: "amber" },
    { value: "cancel", label: "Cancel Appointment", icon: <CancelIcon sx={{ fontSize: 18 }} />, color: "red" },
    { value: "Completed", label: "Mark Completed", icon: <CheckCircleIcon sx={{ fontSize: 18 }} />, color: "emerald" },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary to-primaryLight px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
              <EventIcon className="text-white" />
            </div>
            <h6 className="text-xl font-bold text-white">Appointment Details</h6>
          </div>
          <button
            onClick={handleCancel}
            disabled={appointmentDetail?.fromRescheduleTray && selectReSchedule}
            className={`w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center transition-colors ${appointmentDetail?.fromRescheduleTray && selectReSchedule
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-white/30"
              }`}
            title={appointmentDetail?.fromRescheduleTray && selectReSchedule ? "Please complete reschedule first" : "Close"}
          >
            <CloseIcon className="text-white" sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)] space-y-4">
          {/* Patient Info */}
          <div className="bg-primary/10 rounded-xl p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-bold">
                {formData?.name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <PersonIcon className="text-primary" sx={{ fontSize: 18 }} />
                  <span className="font-semibold text-slate-800">{formData?.name}</span>
                </div>
                {formData?.mobileNo && (
                  <a
                    href={`tel:${formData.mobileNo.replace(/[\s\-\(\)]/g, '')}`}
                    className="flex items-center gap-2 mt-1 transition-all md:pointer-events-none md:cursor-default active:scale-95 touch-manipulation"
                    onClick={(e) => {
                      // Only allow on mobile/touch devices
                      if (window.innerWidth >= 768) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <LocalPhoneIcon
                      className="text-primaryLight md:text-slate-400"
                      sx={{ fontSize: 16 }}
                    />
                    <span className="text-sm text-slate-600 md:text-slate-600">
                      {formData.mobileNo}
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Purpose */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
              <AssignmentIcon sx={{ fontSize: 18 }} className="text-primary" />
              Purpose <span className="text-red-500">*</span>
            </label>
            <select
              name="purposeId"
              value={formData?.purposeId}
              onChange={handleChange}
              className={`w-full px-4 py-2.5 bg-slate-50 border rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-700 ${error ? "border-red-500" : "border-slate-200"
                }`}
            >
              <option value="">Select Purpose</option>
              {purposes?.purpose?.map((item: any, i: number) => (
                <option key={i} value={item?._id}>
                  {item?.purposeName}
                </option>
              ))}
            </select>
            {error && (
              <p className="text-sm text-red-500">Please select a purpose</p>
            )}
          </div>

          {/* Schedule/Reschedule Form */}
          {(selectedOption === "Reschedule" || selectedOption === "Schedule") && (
            <div className="space-y-4">
              {/* Action Label */}
              <div className="flex items-center justify-between px-4 py-2 bg-primary/10 rounded-xl">
                <div className="flex items-center gap-2">
                  {selectedOption === "Schedule" ? (
                    <ScheduleIcon className="text-primary" sx={{ fontSize: 20 }} />
                  ) : (
                    <EventRepeatIcon className="text-primary" sx={{ fontSize: 20 }} />
                  )}
                  <span className="font-semibold text-primary">
                    {selectedOption === "Schedule" ? "Schedule Appointment" : "Reschedule Appointment"}
                  </span>
                </div>
                {selectedOption === "Reschedule" && (
                  <button
                    type="button"
                    onClick={handleMoveToNext}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-primary text-white rounded-lg hover:bg-primaryLight transition-colors text-sm font-medium"
                    title="Move to next available time slot"
                  >
                    <SkipNextIcon sx={{ fontSize: 16 }} />
                    Next Available
                  </button>
                )}
              </div>

              {/* Doctor */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <LocalHospitalIcon sx={{ fontSize: 18 }} className="text-primary" />
                  Doctor
                </label>
                <select
                  name={selectedOption === "Schedule" ? "sDoctorId" : "rDoctorId"}
                  value={selectedOption === "Schedule" ? formData?.sDoctorId : formData.rDoctorId}
                  onChange={handleChange}
                  disabled={selectedOption === "Schedule"}
                  className={`w-full px-4 py-2.5 border border-slate-200 rounded-xl outline-none transition-all text-slate-700 ${selectedOption === "Schedule" ? "bg-slate-100 cursor-not-allowed" : "bg-slate-50 focus:ring-2 focus:ring-primary"
                    }`}
                >
                  {doctor?.map((item: any, i: number) => (
                    <option key={i} value={item?._id}>
                      Dr. {item?.lastName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Date */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <CalendarTodayIcon sx={{ fontSize: 18 }} className="text-primary" />
                  Date
                </label>
                <div className="relative z-20 [&_.react-datepicker-wrapper]:w-full [&_input]:w-full [&_input]:px-4 [&_input]:py-2.5 [&_input]:bg-slate-50 [&_input]:border [&_input]:border-slate-200 [&_input]:rounded-xl [&_input]:outline-none [&_input]:focus:ring-2 [&_input]:focus:ring-primary [&_input]:transition-all">
                  <DatePicker
                    name={selectedOption === "Schedule" ? "sDate" : "rDate"}
                    minDate={new Date()}
                    selected={selectedOption === "Schedule" ? formData.sDate : formData.rDate}
                    onChange={(date: any) =>
                      handleChange({
                        target: {
                          value: date,
                          name: selectedOption === "Schedule" ? "sDate" : "rDate",
                        },
                      })
                    }
                    disabled={selectedOption === "Schedule"}
                  />
                </div>
              </div>

              {/* Time Interval */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <AccessTimeIcon sx={{ fontSize: 18 }} className="text-primary" />
                  Duration
                </label>
                <select
                  name={selectedOption === "Schedule" ? "sInterval" : "rInterval"}
                  value={selectedOption === "Schedule" ? formData?.sInterval : formData.rInterval}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-700"
                >
                  <option value="5">5 minutes</option>
                  <option value="10">10 minutes</option>
                  <option value="15">15 minutes</option>
                  <option value="20">20 minutes</option>
                  <option value="25">25 minutes</option>
                </select>
              </div>

              {/* Time */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <AccessTimeIcon sx={{ fontSize: 18 }} className="text-primary" />
                  Time
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="time"
                    name={selectedOption === "Schedule" ? "sStartTime" : "rStartTime"}
                    value={selectedOption === "Schedule" ? formData.sStartTime : formData.rStartTime}
                    onChange={handleChange}
                    disabled={selectedOption === "Schedule"}
                    className={`flex-1 px-4 py-2.5 border border-slate-200 rounded-xl outline-none transition-all ${selectedOption === "Schedule" ? "bg-slate-100 cursor-not-allowed" : "bg-slate-50 focus:ring-2 focus:ring-primary"
                      }`}
                  />
                  <span className="text-slate-400 font-medium">to</span>
                  <input
                    type="time"
                    name={selectedOption === "Schedule" ? "sEndTime" : "rEndTime"}
                    value={selectedOption === "Schedule" ? formData.sEndTime : formData.rEndTime}
                    onChange={handleChange}
                    className="flex-1 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Action Options (for Completed state) */}
          {selectedOption !== "Reschedule" && selectedOption !== "Schedule" && !appointmentDetail?.fromRescheduleTray && (
            <div className="space-y-3">
              <p className="text-sm font-medium text-slate-700">Select Action</p>
              {actionOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => handleOptionChange(option.value)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all ${selectedOption === option.value
                      ? option.color === "amber"
                        ? "bg-amber-100 text-amber-700 border-2 border-amber-300"
                        : option.color === "red"
                          ? "bg-red-100 text-red-700 border-2 border-red-300"
                          : "bg-emerald-100 text-emerald-700 border-2 border-emerald-300"
                      : "bg-slate-50 text-slate-600 border border-slate-200 hover:bg-slate-100"
                    }`}
                >
                  <span className={selectedOption === option.value ? "" : "text-slate-400"}>
                    {option.icon}
                  </span>
                  {option.label}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex gap-3">
          <button
            type="button"
            onClick={handleCancel}
            className="flex-1 px-6 py-3 bg-white border border-slate-200 text-slate-600 rounded-xl font-medium hover:bg-slate-100 transition-colors flex items-center justify-center gap-2"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            disabled={lodingBtn}
            className="flex-1 px-6 py-3 text-white rounded-xl font-medium hover:shadow-lg transition-all flex items-center justify-center gap-2 disabled:opacity-70 focus:outline-none"
            style={{
              background: 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)',
              boxShadow: '0 4px 6px -1px rgba(23, 77, 122, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!e.currentTarget.disabled) {
                e.currentTarget.style.background = 'linear-gradient(90deg, #1a5f95 0%, #2169a3 100%)';
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.disabled) {
                e.currentTarget.style.background = 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)';
              }
            }}
            onMouseDown={(e) => {
              if (!e.currentTarget.disabled) {
                e.currentTarget.style.background = 'linear-gradient(90deg, #144366 0%, #1a4d73 100%)';
              }
            }}
            onMouseUp={(e) => {
              if (!e.currentTarget.disabled) {
                e.currentTarget.style.background = 'linear-gradient(90deg, #1a5f95 0%, #2169a3 100%)';
              }
            }}
          >
            {lodingBtn ? (
              <>
                <Hourglass
                  visible={true}
                  height="20"
                  width="20"
                  ariaLabel="hourglass-loading"
                  colors={["#fff", "#fff"]}
                />
                Saving...
              </>
            ) : (
              <>
                <SaveIcon sx={{ fontSize: 20 }} />
                Save
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppointmentsSchedule;
